// extracted by mini-css-extract-plugin
export default {"bold":"html_bold__9nQSv","italic":"html_italic__sqD+f","center":"html_center__v49Z8","under":"html_under__PoZd+","divider":"html_divider__DImMG","static_w":"html_static_w__NhXmZ"};